var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSanitize(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 282.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #2b4250;\n      }\n\n      .cls-2 {\n        fill: #1ea548;\n      }\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "sanitize") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M87.5,73.33h70.42V88.75H87.5Z",
    transform: "translate(-50 -8.33)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 141.25,
    width: 145.83,
    height: 80.83
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M195.42,132.5v8.75H50V132.5A43.06,43.06,0,0,1,68.33,97.08H177.5C188.33,104.58,195.42,117.5,195.42,132.5Z",
    transform: "translate(-50 -8.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50,238.75H195.83v8.75a43.74,43.74,0,0,1-43.75,43.75H93.75A43.13,43.13,0,0,1,50,247.92Z",
    transform: "translate(-50 -8.33)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 51.67,
    y: 35.42,
    width: 41.67,
    height: 21.67
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M211.25,62.5,187.08,35h-110A13.42,13.42,0,0,1,63.75,21.67,13.17,13.17,0,0,1,77.08,8.33H197.5a4.73,4.73,0,0,1,3.33,1.25l30.84,35a13.23,13.23,0,0,1-1.25,18.75C224.58,68.75,216.25,68.33,211.25,62.5Z",
    transform: "translate(-50 -8.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M250,114.17a15.84,15.84,0,0,1-31.67,0c0-7.09,9.59-22.92,12.5-27.5a4.29,4.29,0,0,1,7.09,0C240.83,91.25,250,107.08,250,114.17Z",
    transform: "translate(-50 -8.33)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSanitize);
export default __webpack_public_path__ + "static/media/sanitize.adb71163bae3fc449c98634e26558a8b.svg";
export { ForwardRef as ReactComponent };